import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

import appSelectors from '@/redux/app/appSelectors';

import useMatchMedia from '@/hooks/useMatchMedia';
import useOutsideClick from '@/hooks/useOutsideClick';

import RouteNames from '@/router/routes';

import DropdownIcon from '@/images/header/dropdown.svg?react';
import SwardIcon from '@/images/header/sword.svg?react';
import RightIcon from '@/images/right.svg?react';

import s from './nav.module.css';

const MP_URL = import.meta.env.VITE_MP_URL;

function Nav({ closeMenu = () => {} }) {
  const i18n = useSelector(appSelectors.translation);
  const lang = useSelector(appSelectors.language);

  const navRef = useRef();

  const [submenu, setSubmenu] = useState('');

  const handleClick = name => {
    if (name === submenu) setSubmenu('');
    else setSubmenu(name);
  };

  const closeDropdown = () => setSubmenu('');

  const close = () => {
    closeDropdown();
    closeMenu();
  };

  const { isDesktop } = useMatchMedia();

  useOutsideClick(navRef, closeDropdown);

  return (
    <>
      <ul className={s.nav_list} ref={navRef}>
        <li>
          <button
            type="button"
            onClick={() => handleClick('VPS-серверы')}
            className={
              submenu === 'VPS-серверы' ? s.btn_submenu_active : s.btn_submenu
            }
          >
            {i18n.VPS_серверы}
            <DropdownIcon />
          </button>
          {submenu === 'VPS-серверы' && (
            <ul className={s.submenu_list}>
              <li>
                <Link to={RouteNames.VPS_PAID} onClick={close}>
                  {i18n.Наши_тарифы}
                  <RightIcon />
                </Link>
              </li>
              <li>
                <Link to={RouteNames.VPS_MANUAL} onClick={close}>
                  {i18n.Руководство_пользователя}
                  <RightIcon />
                </Link>
              </li>
            </ul>
          )}
        </li>
        <li>
          <button
            type="button"
            onClick={() => handleClick('Онлайн-мониторинг')}
            className={
              submenu === 'Онлайн-мониторинг'
                ? s.btn_submenu_active
                : s.btn_submenu
            }
          >
            {i18n.Онлайн_мониторинг}
            <DropdownIcon />
          </button>
          {submenu === 'Онлайн-мониторинг' && (
            <ul className={s.submenu_list}>
              <li>
                <Link to={RouteNames.MONITORING} onClick={close}>
                  {i18n.Наши_тарифы}
                  <RightIcon />
                </Link>
              </li>
              <li>
                <Link to={RouteNames.MONITORING_MANUAL} onClick={close}>
                  {i18n.Руководство_пользователя}
                  <RightIcon />
                </Link>
              </li>
            </ul>
          )}
        </li>
        <li>
          <button
            type="button"
            onClick={() => handleClick('Рибейт-сервис')}
            className={
              submenu === 'Рибейт-сервис' ? s.btn_submenu_active : s.btn_submenu
            }
          >
            {i18n.Рибейт_сервис}
            <DropdownIcon />
          </button>
          {submenu === 'Рибейт-сервис' && (
            <ul className={s.submenu_list}>
              <li>
                <Link to={RouteNames.REBATE} onClick={close}>
                  {i18n.Наши_тарифы}
                  <RightIcon />
                </Link>
              </li>
              <li>
                <Link to={RouteNames.REBATE_BROKERS} onClick={close}>
                  {i18n.Список_брокеров}
                  <RightIcon />
                </Link>
              </li>
            </ul>
          )}
        </li>
        <li>
          <button
            type="button"
            onClick={() => handleClick('Партнерам')}
            className={
              submenu === 'Партнерам' ? s.btn_submenu_active : s.btn_submenu
            }
          >
            {i18n.Партнерам}
            <DropdownIcon />
          </button>
          {submenu === 'Партнерам' && !isDesktop && (
            <ul className={s.submenu_list}>
              <li>
                <Link to={RouteNames.PARTNER_CLASSIC} onClick={close}>
                  {i18n.Классическая_CPS}
                  <RightIcon />
                </Link>
              </li>
              <li>
                <Link to={RouteNames.PARTNER_MULTILEVEL} onClick={close}>
                  {i18n.Мультилевел}
                  <RightIcon />
                </Link>
              </li>
              <li>
                <Link to={RouteNames.WHITE_LABEL} onClick={close}>
                  White Label
                  <RightIcon />
                </Link>
              </li>
              <li>
                <Link to={RouteNames.RESALE} onClick={close}>
                  {i18n.Реселлинг}
                  <RightIcon />
                </Link>
              </li>
            </ul>
          )}
        </li>
        <li>
          <button
            type="button"
            onClick={() => handleClick('Помощь')}
            className={
              submenu === 'Помощь' ? s.btn_submenu_active : s.btn_submenu
            }
          >
            {i18n.Помощь}
            <DropdownIcon />
          </button>
          {submenu === 'Помощь' && !isDesktop && (
            <ul className={s.submenu_list}>
              <li>
                <Link to={RouteNames.ABOUT_US} onClick={close}>
                  {i18n.О_нас}
                  <RightIcon />
                </Link>
              </li>
              <li>
                <Link to={RouteNames.RATING} onClick={close}>
                  {i18n.Рейтинг_форекс_брокеров}
                  <RightIcon />
                </Link>
              </li>
              <li>
                <Link to={RouteNames.COURSES} onClick={close}>
                  {i18n.Курсы_для_новичков}
                  <RightIcon />
                </Link>
              </li>
              <li>
                <Link to={RouteNames.ROBOT} onClick={close}>
                  {i18n.Разработка_на_заказ}
                  <RightIcon />
                </Link>
              </li>
              <li>
                <Link to={RouteNames.GLOSSARY} onClick={close}>
                  {i18n.Глоссарий_терминов}
                  <RightIcon />
                </Link>
              </li>
            </ul>
          )}
        </li>
        <li>
          <a
            href={`${MP_URL}?lang=${lang}`}
            target="_blank"
            rel="noopener noreferrer"
            onClick={close}
            className={s.btn_submenu}
          >
            Trade Challenge <SwardIcon className={s.sword_icon} />
          </a>
        </li>
      </ul>
      {submenu === 'Партнерам' && isDesktop && (
        <div className={s.submenu_list_partners}>
          <div>
            <p className={s.submenu_list_title}>{i18n.Партнерам}</p>
            <p className={s.submenu_list_text}>
              {i18n.В_данном_разделе_вы_сможете}
            </p>
          </div>
          <ul>
            <li>
              <Link to={RouteNames.PARTNER_CLASSIC} onClick={close}>
                {i18n.Классическая_CPS}
                <RightIcon />
              </Link>
              <p>
                {i18n.Платим_15_с_каждого_платежа} {i18n.привлеченного_клиента}
              </p>
            </li>
            <li>
              <Link to={RouteNames.PARTNER_MULTILEVEL} onClick={close}>
                {i18n.Мультилевел}
                <RightIcon />
              </Link>
              <p>{i18n.Многоуровневая_программа_для_партнеров}</p>
            </li>
            <li>
              <Link to={RouteNames.WHITE_LABEL} onClick={close}>
                White Label
                <RightIcon />
              </Link>
              <p>{i18n.Комплексное_решение_для}</p>
            </li>
            <li>
              <Link to={RouteNames.RESALE} onClick={close}>
                {i18n.Реселлинг}
                <RightIcon />
              </Link>
              <p>{i18n.Хотите_сдавать_в_аренду}</p>
            </li>
          </ul>
        </div>
      )}
      {submenu === 'Помощь' && isDesktop && (
        <div className={s.submenu_list_help}>
          <div>
            <p className={s.submenu_list_title}>{i18n.О_нас}</p>
            <p className={s.submenu_list_text}>
              {i18n.Экосистема_сервисов}
              <br />
              {i18n.для_комфортного_трейдинга}!
            </p>
            <Link
              to={RouteNames.ABOUT_US}
              onClick={close}
              className={s.link_about}
            >
              {i18n.подробнее}
              <RightIcon />
            </Link>
          </div>
          <ul>
            <li>
              <Link to={RouteNames.RATING} onClick={close}>
                {i18n.Рейтинг_форекс_брокеров}
                <RightIcon />
              </Link>
              <p>{i18n.По_принципу_наибольшей_популярности}</p>
            </li>
            <li>
              <Link to={RouteNames.COURSES} onClick={close}>
                {i18n.Курсы_для_новичков}
                <RightIcon />
              </Link>
              <p>{i18n.Базовые_курсы_которые_охватывают}</p>
            </li>
            <li>
              <Link to={RouteNames.ROBOT} onClick={close}>
                {i18n.Разработка_на_заказ}
                <RightIcon />
              </Link>
              <p>{i18n.Услуга_по_созданию_или_доработке_советников}</p>
            </li>
            <li>
              <Link to={RouteNames.GLOSSARY} onClick={close}>
                {i18n.Глоссарий_терминов}
                <RightIcon />
              </Link>
              <p>{i18n.Словарь_самых_распространенных_терминов}</p>
            </li>
          </ul>
        </div>
      )}
    </>
  );
}

export default Nav;

Nav.propTypes = {
  closeMenu: PropTypes.func,
};
